import { Box, Typography } from "@mui/material";
import cluppcitoHappy from "../../../Assets/Clupp_Festejo.png";
import Confetti from "react-confetti";
import { useEffect, useState } from "react";

const AceptPause = ({ state, setState, field }) => {
  const [run, setRun] = useState(true);

  useEffect(() => {
    setTimeout(() => setRun((r) => !r), 5000);
  }, []);

  return (
    <>
      {!state.haveAPause && <Confetti tweenDuration={10000} recycle={run} />}
      <Box textAlign="center" width="100%" padding={0}>
        <img
          src={cluppcitoHappy}
          alt="Cluppcito Happy"
          style={{ width: 150, height: 170, marginBottom: 3 }}
        />
        {state.haveAPause ? (
          <>
            <Typography variant="h6" gutterBottom>
              Ya has pausado tu {state.isADevice ? "dispositivo" : "vehículo"}.
            </Typography>
            <Typography variant="body1">
              No puedes aplicar otra pausa nuevamente en este momento.
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="h6" gutterBottom>
              Ha quedado pausado el seguro de tu{" "}
              <stron>{state.productName}</stron>.
            </Typography>
            <Box
              sx={{
                padding: 2,
                backgroundColor: "#E3F2FD",
                borderRadius: "8px",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Es importante que tomes en cuenta lo siguiente{" "}
                <span role="img" aria-label="ojos">
                  👀
                </span>
                :
              </Typography>
              <ul style={{ paddingLeft: "20px", listStyleType: "disc" }}>
                <li>
                  <Typography variant="body1" gutterBottom color={"#000"}>
                    Reiniciará de manera automática el{" "}
                    <strong>{state.resumesAt}</strong>.
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" gutterBottom color={"#000"}>
                    No cuentas con cobertura esos meses.
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" gutterBottom color={"#000"}>
                    En caso de tener una tarjeta domiciliada, no se harán más
                    cargos durante ese periodo.
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" gutterBottom color={"#000"}>
                    A partir de la fecha que termina la pausa, en caso de tener
                    domiciliada alguna tarjeta, se reactivarán los cargos de
                    manera automática a tu tarjeta.
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" gutterBottom color={"#000"}>
                    En caso de querer reactivar tu seguro y tus cobros antes de
                    la fecha señalada, sólo escríbenos y te ayudaremos con
                    gusto.
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" gutterBottom color={"#000"}>
                    En caso de que tu pago sea por transferencia o depósito,
                    debes realizarlo en la fecha señalada para que no se cancele
                    tu seguro.
                  </Typography>
                </li>
              </ul>
            </Box>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, marginTop: "15px" }}
            >
              ¡Gracias por quedarte con Clupp!
              <span role="img" aria-label="cara de fiesta">
                {" "}
                🥳{" "}
              </span>
            </Typography>
          </>
        )}
      </Box>
    </>
  );
};
export default AceptPause;
